import { useSdk } from "~/sdk"
export const useGuestCart = () => {
  const userSession = useUserSession()
  
  const setGuestCartId = (cartId: string) => {
    userSession.value = {
      ...userSession.value,
      guest_cart_id: cartId
    }
  }

  const getGuestCartId = async () => {
    if(!userSession.value?.guest_cart_id) {
      await getCartId();
    }

    return userSession.value?.guest_cart_id || null
  }

  const getCartId = async () => {
    const emptyCart = await useSdk().magento.createEmptyCart();
    const cartId = emptyCart?.data?.createEmptyCart || ''; 
    setGuestCartId(cartId);
  }

  return {
    getGuestCartId
  }
}
